import DefaultValidation from '@/services/validations/DefaultValidation';
import * as Util from '@/functions/Util';

export default class TipoCulturaValidation extends DefaultValidation{
    validate(model, refs) {
        let validated = true;

        if (refs.idculturaerpInput.required && !model.idtipoculturaerp) {
            refs.idculturaerpInput.focusedOut = true;
            validated = false;
        }

        if (Util.isNull(model.descricao)) {
            refs.descricaoInput.focusedOut = true;
            validated = false;
        }

        return validated;
    }
}